import { EsignatureType } from '~/enums/EsignatureType';
import { FeatureFlagType } from '~/enums/FeatureFlagType';
import { ESignatureIntegrationData } from '~/features/admin/ESignature/types';
import { User } from '~/types/User';
import { featureFlagIncluded } from '~/utils/user';

export type IntegrationV1 = {
  clientId: string;
  config: Record<string, unknown>;
  error: null | { message?: string };
  isDefault: boolean;
  isUserLoggedIn: boolean;
  shouldUseCompanyAccount: boolean | null;
  type: string; // e.g. "docusign"
};

type IntegrationTypeByVersion<T extends boolean> = T extends true
  ? ESignatureIntegrationData
  : IntegrationV1;

export function testHasIntegration(
  currentUser: User,
  integration: IntegrationV1,
  isV2: false,
): boolean;

export function testHasIntegration(
  currentUser: User,
  integration: ESignatureIntegrationData,
  isV2: true,
): boolean;

export function testHasIntegration<T extends boolean>(
  currentUser: User,
  integration: IntegrationTypeByVersion<T>,
  isV2: T,
): boolean {
  if (!currentUser) return false;
  const integrationType = isV2
    ? (integration as ESignatureIntegrationData).integrationType.toLowerCase()
    : (integration as IntegrationV1).type.toLowerCase();

  // Shared logic for feature flag check
  switch (integrationType) {
    case EsignatureType.Adobesign:
      return featureFlagIncluded(currentUser, FeatureFlagType.Adobesign);
    case EsignatureType.Docusign:
      return featureFlagIncluded(currentUser, FeatureFlagType.Docusign);
    default:
      return false;
  }
}
